import { Injectable, signal } from '@angular/core';

export interface AsesorApiResponse  {
  Codigo: number;
  Mensaje: string;
  idasesor: number;
  NombreCompleto: string;
  NumeroDocumento: string;
  TipoAsesor: string;
  CanalVenta: string;
  EstadoPlan: string;
  EsPrincipal: 'Sí' | 'No';
  FechaAlta: string; // "25/07/2024 12:47:48"
  FechaBaja: string | null;
}

@Injectable({ providedIn: 'root' })
export class AsesorStore {
  asesor = signal<AsesorApiResponse | null>(null);
  loading = signal(false);

  setAsesor(data: AsesorApiResponse) {
    this.asesor.set(data);
  }

  clearAsesor() {
    this.asesor.set(null);
  }
}
